export default "__VITE_ASSET__B$TLIryp__"